module.exports = __webpack_public_path__ + "img/Weapon_139.a6eea11a.png";